import { MatDialogConfig } from '@angular/material/dialog/typings/dialog-config';

export const PAYMENTS_INTEGRATION_WARNING_MODAL: MatDialogConfig = {
  data: {
    title: 'ALLOCATE_PAYMENTS.BOOK_PAYMENT_MODAL_WARN_TTL',
    message: 'ALLOCATE_PAYMENTS.BOOK_PAYMENT_MODAL_WARN_MSG',
    confirmBtnText: 'BUTTON.BOOK_PAYMENT',
    confirmBtnIcon: 'payment'
  }
};
